.button{
    @apply text-center rounded  py-1 px-5 ease-out duration-300 
}

.primary{
    @apply bg-green-400 text-white hover:bg-green-300
}

.secondary {
    @apply bg-gray-300 text-gray-600 hover:bg-gray-200
}